import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OAuth2CallbackComponent as OAuth2CallbackReceiver } from './lib/components/oauth2-callback/oauth2-callback.component';
import { SessionSigninComponent as SignInDialog } from './lib/components/session-signin/session-signin.component';
import { SessionSelectorComponent as SessionSelector } from './lib/components/session-selector/session-selector.component';
import { DropdownSessionSelectorComponent as DropdownSessionSelector } from './lib/components/active-session-badge/active-session-badge.component';

@NgModule({
  declarations: [],
  imports: [CommonModule, OAuth2CallbackReceiver, SignInDialog, SessionSelector, DropdownSessionSelector],
  exports: [OAuth2CallbackReceiver, SignInDialog, SessionSelector, DropdownSessionSelector],
})
export class SessionsModule {}
